import { render, staticRenderFns } from "./r-christmas-products.vue?vue&type=template&id=511678a0"
import script from "./r-christmas-products.vue?vue&type=script&lang=js"
export * from "./r-christmas-products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('511678a0')) {
      api.createRecord('511678a0', component.options)
    } else {
      api.reload('511678a0', component.options)
    }
    module.hot.accept("./r-christmas-products.vue?vue&type=template&id=511678a0", function () {
      api.rerender('511678a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-christmas/r-christmas-products.vue"
export default component.exports